import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { content } from "../../data/content";
import { burstConfetti } from "../../lib/confetti";
import { Reveal } from "./Reveal";

const CANDLES = [0, 1, 2, 3, 4];

export function WishCake() {
  const [out, setOut] = useState([]);

  const blow = (i) => {
    if (out.includes(i)) return;
    const next = [...out, i];
    setOut(next);
    if (next.length === CANDLES.length) {
      setTimeout(() => burstConfetti(), 250);
    }
  };

  const allOut = out.length === CANDLES.length;

  return (
    <section
      data-testid="wish-section"
      className="relative w-full bg-butter px-5 md:px-10 py-24 md:py-32 overflow-hidden border-y-[3px] border-ink"
    >
      <div className="max-w-3xl mx-auto text-center">
        <Reveal>
          <p className="font-accent text-3xl md:text-5xl text-rose -rotate-2 mb-1">
            {content.wish.kicker}
          </p>
          <h2 className="font-heading font-black uppercase tracking-tighter text-4xl md:text-6xl text-ink">
            {content.wish.title}
          </h2>
          <p className="font-body font-semibold text-base md:text-xl text-ink/70 mt-3">
            {allOut ? " " : content.wish.subtitle}
          </p>
        </Reveal>

        <div className="mt-14 flex flex-col items-center">
          {/* candles */}
          <div className="flex items-end justify-center gap-3 md:gap-5 mb-[-3px] z-10">
            {CANDLES.map((i) => (
              <button
                key={i}
                data-testid={`candle-${i}`}
                onClick={() => blow(i)}
                aria-label={`Apagar vela ${i + 1}`}
                className="relative flex flex-col items-center outline-none group"
              >
                {/* flame */}
                <span className="h-8 flex items-end justify-center">
                  <AnimatePresence>
                    {!out.includes(i) && (
                      <motion.span
                        initial={{ scale: 1, opacity: 1 }}
                        animate={{ scaleY: [1, 1.25, 1], scaleX: [1, 0.85, 1] }}
                        exit={{ scale: 0, y: -14, opacity: 0 }}
                        transition={{ duration: 0.6, repeat: Infinity, ease: "easeInOut" }}
                        className="block w-3 h-5 rounded-full"
                        style={{
                          background:
                            "radial-gradient(circle at 50% 70%, #FFF6B0 0%, #FCD34D 40%, #F97316 80%)",
                          boxShadow: "0 0 12px rgba(249,115,22,0.7)",
                        }}
                      />
                    )}
                  </AnimatePresence>
                </span>
                {/* wick + candle */}
                <span className="w-3 md:w-3.5 h-14 md:h-16 rounded-t-sm border-[3px] border-ink bg-white relative overflow-hidden">
                  <span className="absolute inset-x-0 top-1/3 h-1.5 bg-rose" />
                  <span className="absolute inset-x-0 bottom-2 h-1.5 bg-grape" />
                </span>
              </button>
            ))}
          </div>

          {/* cake */}
          <div className="relative">
            <div className="w-72 md:w-96 h-10 rounded-t-2xl bg-lilac border-[3px] border-ink border-b-0 relative overflow-hidden">
              <div className="absolute inset-x-0 top-0 flex justify-around px-4">
                {[...Array(8)].map((_, i) => (
                  <span key={i} className="w-3 h-5 bg-rose rounded-b-full" />
                ))}
              </div>
            </div>
            <div className="w-72 md:w-96 h-24 md:h-28 bg-blush border-[3px] border-ink shadow-brutal-lg flex items-center justify-center">
              <span className="font-accent text-3xl md:text-4xl text-ink/60">
                {content.recipientFirst}
              </span>
            </div>
          </div>
        </div>

        <div className="mt-10 px-3 min-h-[3.5rem] flex items-center justify-center">
          <AnimatePresence>
            {allOut && (
              <motion.p
                data-testid="wish-done"
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                className="font-accent text-2xl md:text-4xl text-rose max-w-2xl mx-auto leading-snug text-center"
              >
                {content.wish.done}
              </motion.p>
            )}
          </AnimatePresence>
        </div>
      </div>
    </section>
  );
}
